import { render, staticRenderFns } from "./form-component-activitydomain.vue?vue&type=template&id=48fee61f&scoped=true"
import script from "./form-component-activitydomain.vue?vue&type=script&lang=ts"
export * from "./form-component-activitydomain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fee61f",
  null
  
)

export default component.exports